"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppProvider = exports.AppConsumer = exports.AppContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _abortController = _interopRequireDefault(require("abort-controller"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _api = _interopRequireDefault(require("../common/api"));

var _util = _interopRequireDefault(require("../common/util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AppContext = /*#__PURE__*/_react["default"].createContext();

exports.AppContext = AppContext;
var AppConsumer = AppContext.Consumer;
exports.AppConsumer = AppConsumer;

var AppProvider = /*#__PURE__*/function (_Component) {
  _inherits(AppProvider, _Component);

  var _super = _createSuper(AppProvider);

  function AppProvider(props) {
    var _this;

    _classCallCheck(this, AppProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "keystoneLogin", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event, loginUserForm) {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault(); // throw error if username or password are null or empty

                if (!(loginUserForm.userName === null || loginUserForm.userName.trim() === '')) {
                  _context.next = 3;
                  break;
                }

                throw new Error('Please enter username!!');

              case 3:
                if (!(loginUserForm.password === null || loginUserForm.password.trim() === '')) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Please enter password!!');

              case 5:
                _context.next = 7;
                return _api["default"].keystoneLogin(loginUserForm);

              case 7:
                params = _context.sent;

                if (!(params !== null && params.id_token !== 'null')) {
                  _context.next = 15;
                  break;
                }

                _this.setNotification(null);

                _context.next = 12;
                return _this.setTokens(params.id_token, params.token_type);

              case 12:
                if (!(params.forceChangePWD === 'true')) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", true);

              case 14:
                return _context.abrupt("return", false);

              case 15:
                if (!(params !== null && params.error_description !== 'null')) {
                  _context.next = 19;
                  break;
                }

                throw new Error(params.error_description);

              case 19:
                throw new Error('Invalid Username Or Password.');

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "login", function () {
      var loginUrl = _util["default"].getSentienceLoginUrl();

      window.location.replace(loginUrl);
    });

    _defineProperty(_assertThisInitialized(_this), "cookieLogin", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _api["default"].cookieLogin();

            case 3:
              result = _context2.sent;

              if (!(result.response && result.response.id_token && result.response.id_token !== 'null')) {
                _context2.next = 8;
                break;
              }

              _context2.next = 7;
              return _this.setTokens(result.response.id_token, result.response.token_type);

            case 7:
              return _context2.abrupt("return", true);

            case 8:
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);

            case 13:
              return _context2.abrupt("return", false);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "logout", function () {
      var user = _this.state.user;

      if (_util["default"].getSentienceEnableFlag()) {
        _api["default"].logout(user, _this.clearUserInfo);
      } else {
        // EVS2-633 : JWT Token Logout implementation
        _api["default"].keystoneLogout(user, _this.clearUserInfo);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearUserInfo", function () {
      _this.setState({
        isAuthenticated: false,
        user: null,
        isSessionTimeAppModelOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updatePassword", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(loginUserForm) {
        var user;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                user = _this.state.user;
                _context3.prev = 1;
                _context3.next = 4;
                return _api["default"].updatePassword(user.idToken, loginUserForm);

              case 4:
                return _context3.abrupt("return", true);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);
                console.error(_context3.t0);

                _this.handleModalError(_context3.t0);

                return _context3.abrupt("return", _context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 7]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setTokens", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(idToken, accessToken) {
        var user, userData;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // eslint-disable-next-line no-underscore-dangle
                user = _this._decodeToken(idToken, accessToken);

                _this.setState({
                  user: user
                }); // after decoding token returned from forge, fetch user data from user service


                _context4.next = 4;
                return _api["default"].getUserData(user);

              case 4:
                userData = _context4.sent;

                _this.setState({
                  userData: userData,
                  isAuthenticated: true
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "_decodeToken", function (idToken, accessToken) {
      var decoded = (0, _jwtDecode["default"])(idToken);

      if (decoded.isUserAdmin !== undefined) {
        _this.setState({
          isAdmin: decoded.isUserAdmin
        });
      }

      if (decoded.userNotificationDays !== undefined) {
        _this.handleError("Your password will expire in ".concat(decoded.userNotificationDays, " days, update your password before your account gets locked"));
      }

      return {
        firstName: decoded.given_name,
        lastName: decoded.family_name,
        email: decoded.sub,
        tokenExpiration: decoded.exp,
        idToken: idToken,
        accessToken: accessToken
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setNotification", function (notificationText, severity) {
      var carryForward = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (notificationText === null) {
        _this.setState({
          notification: {
            hasNotification: false,
            notificationText: '',
            severity: '',
            carryForward: carryForward
          }
        });
      } else {
        _this.setState({
          notification: {
            hasNotification: true,
            notificationText: notificationText,
            severity: severity,
            carryForward: carryForward
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setNotificationModal", function (notificationText, severity) {
      if (notificationText === null) {
        _this.setState({
          notificationModal: {
            hasNotification: false,
            notificationText: '',
            severity: ''
          }
        });
      } else {
        _this.setState({
          notificationModal: {
            hasNotification: true,
            notificationText: notificationText.toString(),
            severity: severity
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (err) {
      if (err.message === 'Unauthorised Access !!') {
        _this.setState({
          isSessionTimeAppModelOpen: true
        });
      } else {
        _this.setNotification(err.message, 'critical');
      }

      return err;
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalError", function (err) {
      _this.setNotificationModal(err.message, 'critical');

      if (err.message === 'Unauthorised Access !!') {
        _this.logout();
      }

      return err;
    });

    _defineProperty(_assertThisInitialized(_this), "registerReloadFunction", function (reload) {
      _this.setState({
        reload: reload
      });

      _this.reloadInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this$state, reloadInProgress, isSessionTimeAppModelOpen, abortController;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$state = _this.state, reloadInProgress = _this$state.reloadInProgress, isSessionTimeAppModelOpen = _this$state.isSessionTimeAppModelOpen;

                if (!(!reloadInProgress && !isSessionTimeAppModelOpen)) {
                  _context5.next = 7;
                  break;
                }

                abortController = new _abortController["default"]();

                _this.setState({
                  reloadInProgress: true,
                  abortController: abortController
                });

                _context5.next = 6;
                return reload(abortController.signal);

              case 6:
                _this.setState({
                  reloadInProgress: false,
                  abortController: null
                });

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })), _util["default"].getReloadInterval());
    });

    _defineProperty(_assertThisInitialized(_this), "unregisterReloadFunction", function () {
      var abortController = _this.state.abortController;

      if (_this.reloadInterval) {
        clearInterval(_this.reloadInterval);
      }

      if (abortController) {
        abortController.abort();
      }

      _this.setState({
        reload: function reload() {}
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setRedirectFunction", function (redirect) {
      _this.setState({
        redirect: redirect
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSidebar", function () {
      var isSidebarCollapsed = _this.state.isSidebarCollapsed;

      _this.setState({
        isSidebarCollapsed: !isSidebarCollapsed
      });
    });

    _this.state = {
      user: null,
      userData: null,
      isAuthenticated: false,
      isAdmin: false,
      notification: {
        hasNotification: false,
        notificationText: '',
        severity: '',
        carryForward: false
      },
      notificationModal: {
        hasNotification: false,
        notificationText: '',
        severity: ''
      },
      isSessionTimeAppModelOpen: false,
      isSidebarCollapsed: false,
      reload: function reload() {},
      reloadInProgress: false,
      redirect: null,
      abortController: null
    };
    return _this;
  }

  _createClass(AppProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state2 = this.state,
          user = _this$state2.user,
          userData = _this$state2.userData,
          isAuthenticated = _this$state2.isAuthenticated,
          isAdmin = _this$state2.isAdmin,
          reload = _this$state2.reload,
          redirect = _this$state2.redirect,
          abortController = _this$state2.abortController,
          notification = _this$state2.notification,
          notificationModal = _this$state2.notificationModal,
          isSessionTimeAppModelOpen = _this$state2.isSessionTimeAppModelOpen,
          isSidebarCollapsed = _this$state2.isSidebarCollapsed;
      return /*#__PURE__*/_react["default"].createElement(AppContext.Provider, {
        value: {
          // state vars
          isAuthenticated: isAuthenticated,
          user: user,
          userData: userData,
          notification: notification,
          notificationModal: notificationModal,
          isAdmin: isAdmin,
          isSessionTimeAppModelOpen: isSessionTimeAppModelOpen,
          isSidebarCollapsed: isSidebarCollapsed,
          reload: reload,
          redirect: redirect,
          abortController: abortController,
          // api methods
          login: this.login,
          logout: this.logout,
          setTokens: this.setTokens,
          setNotification: this.setNotification,
          setNotificationModal: this.setNotificationModal,
          handleError: this.handleError,
          handleModalError: this.handleModalError,
          keystoneLogin: this.keystoneLogin,
          cookieLogin: this.cookieLogin,
          updatePassword: this.updatePassword,
          registerReloadFunction: this.registerReloadFunction,
          unregisterReloadFunction: this.unregisterReloadFunction,
          setRedirectFunction: this.setRedirectFunction,
          toggleSidebar: this.toggleSidebar
        }
      }, children);
    }
  }]);

  return AppProvider;
}(_react.Component);

exports.AppProvider = AppProvider;
AppProvider.propTypes = {
  children: _propTypes["default"].node.isRequired
};